export const link = (param: string) => {
  return `<a href='${param}' target='_blank'>${param}</a>`;
};
